import { useEffect, useRef, useState } from 'react'
import { CSSTransition } from 'react-transition-group'
import classNames from 'classnames'

import styles from './Carousel.module.css'
import { MyContainer } from '~/components/ui/MyContainer'
import { to1440Image } from '~/utils'

interface Props {
  list: Array<{
    img: string
    title: string
    subTitle: string
    id: number
    redirectUrl?: string
    isBanner?: boolean
  }>
}

export default function Carousel({ list }: Props) {
  const [active, setActive] = useState(0)
  const [lock, setLock] = useState(false)
  const intervalRef = useRef(0)
  useEffect(() => {
    if (lock) {
      window.clearInterval(intervalRef.current)
      return
    }
    intervalRef.current = window.setInterval(() => {
      setActive(pre => {
        return ++pre % list.length
      })
    }, 10000)

    return () => {
      window.clearInterval(intervalRef.current || 0)
    }
  }, [lock, list])

  return (
    <div className={classNames('relative w-full h-[380px]', styles.carousel)}>
      {list.map((item, index) => {
        return (
          <CSSTransition
            key={item.id}
            classNames="fade"
            unmountOnExit
            in={active === index}
            timeout={300}
          >
            <div
              className="w-full h-full bg-cover bg-center absolute top-0 right-0 bottom-0 left-0"
              style={{
                backgroundImage: `linear-gradient(
                  to bottom,
                  rgba(0, 0, 0, 0.1),
                  rgba(0, 0, 0, 0.5)
                ), url(${to1440Image(item.img)})`,
              }}
            ></div>
          </CSSTransition>
        )
      })}

      <MyContainer className="relative w-full h-[380px]">
        <div className="relative w-full h-full">
          <div
            className={classNames(
              'absolute right-0 top-1/2 -translate-y-1/2',
              styles.nav
            )}
            onMouseEnter={() => {
              setLock(true)
            }}
            onMouseLeave={() => {
              setLock(false)
            }}
          >
            {list.map((item, index) => {
              return (
                <div
                  key={item.id}
                  className={classNames(styles.navItem, {
                    [styles.navItemActive]: active === index,
                  })}
                  onMouseEnter={() => setActive(index)}
                  onClick={() => {
                    const _it = list[active]
                    let redirectUrl = `${process.env.NEXT_PUBLIC_SITE}/ai-competition/${_it.id}`
                    if (_it.isBanner) {
                      // 未配置链接 直接return
                      if (!_it.redirectUrl) {
                        return
                      }
                      redirectUrl = _it.redirectUrl
                    }
                    window.open(redirectUrl, '_blank')
                  }}
                >
                  <div className={styles.navItemTitle}>{item.title}</div>
                  <div
                    className={classNames(
                      styles.navItemSubTitle,
                      'text-neutral-900'
                    )}
                  >
                    {item.subTitle}
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </MyContainer>
    </div>
  )
}
